import api from '@api';
import { call, put, takeEvery } from 'redux-saga/effects';
import {
    getProvidersListFetchSuccess,
    getProvidersListFetchFailure,
    getWaitingProvidersListFetchSuccess,
    getWaitingProvidersListFetchFailure,
} from './reducer';
import { ProvidersListResType, ProvidersListWaitingResType } from 'src/types/providersList';

const getProvidersListFetchRequest = async (system?: string, forceAll?: boolean) => {
    const res = await api('get', forceAll ? 'api/secure/providers/all' : `api/secure/providers${system ? `?system=${system}` : ''}`);
    return res.data.data;
};

function* getProvidersListFetch(action?: { type: string, payload: { system?: string, forceAll?: boolean } }) {
    try {
        const response: ProvidersListResType = yield call((): any => getProvidersListFetchRequest(action?.payload.system, action?.payload.forceAll));
        yield put(getProvidersListFetchSuccess({response, system: action?.payload.system}));
    } catch (error) {
        yield put(getProvidersListFetchFailure({ error }));
    }
}

export function* getProvidersListFetchWatch() {
    yield takeEvery('providersList/getProvidersListFetch', getProvidersListFetch);
}

const getWaitingProvidersListFetchRequest = async () => {
    const res = await api('get', 'api/secure/shoptet/eshops/registration?active=0');
    return res.data;
};

function* getWaitingProvidersListFetch(action: { type: string }) {
    try {
        const response: ProvidersListWaitingResType = yield call((): any => getWaitingProvidersListFetchRequest());
        yield put(getWaitingProvidersListFetchSuccess(response));
    } catch (error) {
        yield put(getWaitingProvidersListFetchFailure({ error }));
    }
}

export function* getWaitingProvidersListFetchWatch() {
    yield takeEvery('providersList/getWaitingProvidersListFetch', getWaitingProvidersListFetch);
}
